import { invalidatePageDataCacheEntries } from "./usePageData.js";
import { invalidateShellDataCache } from "./useShellData.js";
import { publishOrderDataChange } from "../utils/orderDataSync.js";

export const ORDER_MUTATION_INVALIDATED_API_URLS = ["/api/results/latest"];
export const DATA_MANAGER_STATE_URL = "/api/data-manager/state";

export function invalidateDataManagerStateCache() {
  invalidatePageDataCacheEntries([DATA_MANAGER_STATE_URL]);
}

export async function applySuccessfulDataManagerMutation({
  invalidatedApiUrls = [],
  loadState,
  shouldReload = true,
  actionKey = "",
}) {
  // Toujours invalider le cache Data Manager pour que le reload voie les mutations.
  invalidateDataManagerStateCache();
  invalidatePageDataCacheEntries(invalidatedApiUrls);
  invalidateShellDataCache();
  if (/^(orders?:|import:dispatch-saves$|railway-sync$)/.test(actionKey)) {
    publishOrderDataChange("data-manager");
  }

  if (shouldReload) {
    await loadState({ silent: true });
  }
}
